import React from 'react';
import { HeroVariant42 } from '../components/HeroVariant42';
import { Services } from '../components/Services';
import { WhyUs } from '../components/WhyUs';
import { FAQ } from '../components/FAQ';
import { Testimonials } from '../components/Testimonials';
import { Consultation } from '../components/Consultation';
import { CookieBanner } from '../components/CookieBanner';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { FloatingContact } from '../components/FloatingContact';
export function LandingPage42() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-1645">
      <Navigation data-id="element-1646" />
      <main data-id="element-1647">
        <HeroVariant42 data-id="element-1648" />
        <WhyUs data-id="element-1649" />
        <Services data-id="element-1650" />
        <FAQ data-id="element-1651" />
        <Testimonials data-id="element-1652" />
        <Consultation data-id="element-1653" />
      </main>
      <Footer data-id="element-1654" />
      <CookieBanner data-id="element-1655" />
      <FloatingContact data-id="element-1656" />
    </div>;
}